module.exports = __webpack_public_path__ + "img/V-Ray.b3114ed8.png";